import { getStore } from '../../../../../init-store';
import { closeChatRecordNotification } from '../../../../pages/call/features/chat';
import { toggleMuteAction } from '../../../../pages/call/features/device/slice';
import {
    admitAllWaitingRoomPeersAction,
    admitWaitingRoomPeerAction,
    showWaitingRoomSidebarAction,
} from '../../../../pages/call/features/waiting-rooms/slice';
import { downloadChatHistoryFile } from '../../../../pages/call/helpers/download-chat-history-file';
import { NotificationId } from '../../../../pages/call/types';
import { setFetchingStatus } from '../../../../pages/conferences-history/features/fetching/slice';
import { scrollThresholdReached } from '../../../../pages/conferences-history/features/history-items/slice';
import { ACTION, FEATURE } from '../../../helpers/logger-enums';
import { createLogger } from '../../../helpers/loggerFacade';
import { countMetrika } from '../../../helpers/metrika';
import { SettingsSectionKey } from '../../settings-modal/constants';
import { openSettingsModalAction } from '../../settings-modal/slice';
import { hideNotification } from './slice';

const logger = createLogger('ps-notifications-actions');

/*
По скольку коммуникация с нотифайками ведется через стор,
мы не можем прокидывать через него функции для выполнения.
getActionOnClick возвращается обработчик клика по ID нотифайки.
*/

export const getActionOnClick = (notificationId: string, sessionId: string, params?: Record<string, unknown>) => {
    const store = getStore();
    let handler: (() => void) | (() => true);
    switch (notificationId) {
        case NotificationId.PLEASE_UNMUTE:
            handler = () => {
                logger.startFeatureDelta({
                    feature: FEATURE.MUTE,
                    action: ACTION.MIC_ON,
                });
                store.dispatch(toggleMuteAction({ type: 'audio' }));
            };
            break;
        case NotificationId.CHAT_HISTORY_SAVE: {
            handler = () => {
                if (params && params.isCloseNotificationAction) {
                    store.dispatch(closeChatRecordNotification(true));
                    return;
                }
                downloadChatHistoryFile(store.getState().call.chat.chatHistory || '');
                store.dispatch(closeChatRecordNotification(true));
            };
            break;
        }
        case NotificationId.PLAN_CALL_SUCCESS:
            handler = () => {
                countMetrika('main_screen', 'planning_screen', 'go_to_calendar', sessionId);
            };
            break;
        case NotificationId.WAITING_ROOM_NEW_PEER: {
            handler = () => {
                logger.startFeatureDelta({
                    feature: FEATURE.WAITING_ROOM,
                    action: ACTION.ALLOW_PARTICIPANT,
                    id: params?.id as string,
                });

                store.dispatch(
                    admitWaitingRoomPeerAction({
                        peerId: params?.id as string,
                        uid: params?.uid as string,
                        fromToast: true,
                    })
                );
            };
            break;
        }
        case NotificationId.WAITING_ROOM_OVERFLOW:
        case NotificationId.WAITING_ROOM_NEW_PEERS: {
            handler = () => {
                if (params?.type === 'admit-all') {
                    logger.startFeatureDelta({
                        feature: FEATURE.WAITING_ROOM,
                        action: ACTION.ALLOW_SEVERAL,
                    });

                    store.dispatch(admitAllWaitingRoomPeersAction({ fromToast: true }));
                } else {
                    countMetrika('waiting_rooms', 'popup_actions', 'people_waiting_view_press');
                    store.dispatch(showWaitingRoomSidebarAction());
                }
            };
            break;
        }
        case NotificationId.WAITING_ROOM_CONFERENCE_LIMIT: {
            handler = () => {
                countMetrika('waiting_rooms', 'popup_actions', 'limit_reached_view_press');
                store.dispatch(showWaitingRoomSidebarAction());
                return true;
            };
            break;
        }
        case NotificationId.NETWORK_QUALITY_HIDE_VIDEO:
        case NotificationId.NETWORK_QUALITY_SHOW_VIDEO: {
            handler = () => {
                store.dispatch(openSettingsModalAction({ sectionKey: SettingsSectionKey.Camera }));
            };
            break;
        }
        case NotificationId.CONF_HISTORY_FETCHING_FAILED: {
            handler = () => {
                store.dispatch(setFetchingStatus(null));
                store.dispatch(scrollThresholdReached());
            };
            break;
        }
        case NotificationId.REPORT_ERROR: {
            handler = () => {
                store.dispatch(openSettingsModalAction({ sectionKey: SettingsSectionKey.Help }));
            };
            break;
        }
        default:
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            handler = () => {};
    }
    return () => {
        const keepNotification = handler();
        if (!keepNotification) {
            getStore().dispatch(hideNotification(notificationId));
        }

        const metrika = params?.metrika;
        if (metrika !== undefined && Array.isArray(metrika)) {
            countMetrika(...metrika);
        }
    };
};
